import {
  useAddUserToRoleMutation,
  useLazyGetRoleExternalUsersQuery,
  useLazyGetRoleUsersQuery,
  useRemoveUserFromRoleMutation,
} from 'app/services/system.service'
import SettingsHeader from 'features/settings/SettingsHeader'
import { DROPDOWN, ROLES, TITLES } from 'locales/locales'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { GridColumn } from '@progress/kendo-react-grid'
import ValueSlider from 'components/kendo/grid/ValueSlider'
import BackButton from 'components/button/BackButton'
import Avatar, { AvatarSize } from 'components/avatar/Avatar'
import { FixMeLater } from 'types'
const RolesUserManagement = () => {
  interface DataState {
    take: number
    skip: number
    filter: {
      logic: 'and' | 'or'
      filters: FixMeLater[] 
    }
    sort?: FixMeLater
  }
  interface IUser {
    _id: string
    name: string
  }
  const [lazygetRoleUsers] = useLazyGetRoleUsersQuery()
  const [lazygetRoleExternalUsers] = useLazyGetRoleExternalUsersQuery()
  const [addUserToRole] = useAddUserToRoleMutation()
  const [removeUserFromRole] = useRemoveUserFromRoleMutation()
  const [isSelectAllLeftChecked, setIsSelectAllLeftChecked] = useState(false);
  const [isSelectAllRightChecked, setIsSelectAllRightChecked] = useState(false);
  const { roleId = '' } = useParams<{ roleId: string }>()
  const { t } = useTranslation()
  const [dataState, setDataState] = useState<DataState>({
    take: 10,
    skip: 0,
    filter: {
      logic: 'and',
      filters: [],
    },
  })
  const [dataStateUnselected, setDataStateUnselected] = useState<DataState>({
    take: 10,
    skip: 0,
    filter: {
      logic: 'and',
      filters: [],
    },
  })

    const [refresh, setRefresh] = useState<boolean>(false)
    const [roleUsers, setRoleUsers] = useState<IUser[]>([])
    const [roleUsersData, setRoleUsersData] = useState<IUser[]>([])
    const [roleUnSelectedUsers, setRoleUnSelectedUsers] = useState<IUser[]>([])
    const [selected, setSelected] = useState<FixMeLater>([])
    const [unSelected, setUnSelected] = useState<FixMeLater>([])
    const [roleUnSelectedUsersData, setRoleUnSelectedUsersData] = useState<IUser[]>([]);
  const getRoleUsers = async () => {
    const responseRoles = await lazygetRoleUsers({
      ...dataState,
      count: true,
      id: roleId,
    })
    //console.log(responseRoles)
    setRoleUsers(responseRoles.data)
    setRoleUsersData(responseRoles.data.data)
  }
  useEffect(() => {
    getRoleUsers()
  }, [dataState, refresh])
  const getRoleExternalUsers = async () => {
    const responseRoles = await lazygetRoleExternalUsers({
      ...dataStateUnselected,
      count: true,
      id: roleId,
    })
    setRoleUnSelectedUsersData(responseRoles.data.data);
    setRoleUnSelectedUsers(responseRoles.data)
  }
  useEffect(() => {
    getRoleExternalUsers()
  }, [dataStateUnselected, refresh])
  const onDataStateChange = (e: FixMeLater) => {
    setDataState(e.dataState)
  }
  const onDataStateChangeUnselected = (e: FixMeLater) => {
    const { skip, take, sort } = e.dataState
    setDataStateUnselected({
      ...dataStateUnselected,
      skip,
      take,
      sort,
    })
  }
  const onChangeUnSelected = (dataItem: FixMeLater, isSelectedOnGrid: boolean) => {
    isSelectedOnGrid
      ? setUnSelected([...unSelected, dataItem])
      : setUnSelected(unSelected.filter((selected: FixMeLater) => selected._id !== dataItem._id))
  }
  const onClickForward = async () => {
    if (unSelected.length) {
      await addUserToRole({
        _id: roleId,
        members: unSelected.map((us: FixMeLater) => us._id),
      })
      setSelected([])
     
      setIsSelectAllLeftChecked(false)
      setIsSelectAllRightChecked(false)
      setRefresh(!refresh)
    }
  }

  const selectAllUnselectedUsers = () => {
    const allUnselectedUsers = roleUnSelectedUsersData.map(user => user);
    setUnSelected(allUnselectedUsers);
    const newSelectedUsers = allUnselectedUsers.filter(unselectedUser =>
      !selected.some((selectedUser: { _id: string }) => selectedUser._id === unselectedUser._id)
    );
    setSelected([...selected, ...newSelectedUsers]);
  };


  const unselectAllUsersLeft = () => {
    setUnSelected([]);
  };

  const selectAllRightTableUsers = () => {
    setSelected((prevSelected: { _id: FixMeLater }[]) => {
      const combinedUsers = [...prevSelected, ...roleUsersData.filter(user => 
        !prevSelected.some((selectedUser: { _id: FixMeLater }) => selectedUser._id === user._id))];
      
      return combinedUsers;
    }); 
  };
  
  const onChangeSelected = (dataItem: FixMeLater, isSelectedOnGrid: boolean) => {
    isSelectedOnGrid
      ? setSelected([...selected, dataItem])
      : setSelected(selected.filter((selected: FixMeLater) => selected._id !== dataItem._id))
  }
  const onClickBack = async () => {
    if (selected.length) {
      await removeUserFromRole({
        _id: roleId,
        members: selected.map((us: FixMeLater) => us._id),
      })
      setUnSelected([])
      setIsSelectAllLeftChecked(false)
      setIsSelectAllRightChecked(false)
      setRefresh(!refresh)
    }
  }
  const onFilterChangeUnselected = (e: FixMeLater) => {
    console.log(e)
    setDataStateUnselected({
      ...dataStateUnselected,
      filter: e.filter,
    })
  }


 const handleSelectAllLeft = () => {
      setIsSelectAllLeftChecked(prev => {
        if (!prev) {
          selectAllUnselectedUsers();
        } else {
      unselectAllUsersLeft();
        setSelected([]);
      }
      return !prev;
      });
  };
  
  const handleSelectAllRight = () => {
      setIsSelectAllRightChecked(prev => {
      if (!prev) {
        selectAllRightTableUsers();
      } else {
        setSelected([]);
      }
        return !prev;
      });
    };

    const CustomCellForAvatar = (props: FixMeLater) => {
      return (
        <td
          {...props.tdProps}
          colSpan={1}
          style={{
            color: props.color,
          }}
        >
          <Avatar
            type={undefined}
            source={props.children}
            text={props.children}
            size={AvatarSize.average}
         
            />
       
        </td>
      );
    };
    
    const avatarCustomCell = (props: FixMeLater) => (
      <CustomCellForAvatar {...props} color={"red"} />
    );

  return (
      <Wrapper>
        <HeaderContainer>
      <BackButtonAndTitle>
        <BackButton />
        <SettingsHeader title={t(TITLES.ROLE_SETTINGS_TITLE)} />
      </BackButtonAndTitle>
    </HeaderContainer>
      
        <ValueSlider
          leftTitle={t(DROPDOWN.ALL_USERS)}
          rightTitle={t(ROLES.USERS_IN_ROLE)}
          onSelectAllLeft={handleSelectAllLeft}
          onSelectAllRight={handleSelectAllRight}
          isSelectAllLeftChecked={isSelectAllLeftChecked}
          isSelectAllRightChecked={isSelectAllRightChecked}
          datasourceLeft={roleUnSelectedUsers}
          dataStateLeft={dataStateUnselected}
          onDataStateChangeLeft={onDataStateChangeUnselected}
          selectedListLeft={unSelected}
          onChangeSelectedLeft={onChangeUnSelected}
          onFilterChangeLeft={onFilterChangeUnselected}
          datasourceRight={roleUsers}
          dataStateRight={dataState}
          selectedListRight={selected}  
          onDataStateChangeRight={onDataStateChange}
          onChangeSelectedRight={onChangeSelected}
          onClickForward={onClickForward}
          onClickBack={onClickBack}
        >
           <GridColumn field="avatar" cells={{ data: avatarCustomCell }} width="70px" />
          <GridColumn field="fullname" title="fullname" filterable={true} />
      
        </ValueSlider>
      </Wrapper>
  )
}
export default RolesUserManagement

  const Wrapper = styled.div`
    /* margin-top: 40px; */
    padding: 0px 30px;
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .buttonContainer {
      display: flex;
      justify-content: space-between;
      padding: 0 10px 0 0 ;
    }
  ` 



const HeaderContainer = styled.div`
  display: flex;
  align-items: center; // Align items in the center vertically
  justify-content: start; // Align items to the start of the container
  width: 100%;
`;

const BackButtonAndTitle = styled.div`
  display: flex;
  align-items: center; // Ensure vertical alignment is centered
  gap: 10px; // Space between back button and the title
  flex-grow: 1; // Allows this container to take up all available space
`;


